<div>
  <div *ngFor="let block of sidebarInfo">
    <div class="block-title" *ngIf="block.title">{{ block.title | translate }}</div>
    <div class="item-group" *ngFor="let item of block.elements">
      <div>{{ item.title | translate}}</div>
      <div>{{ item.value }}</div>
      <div *ngIf="item.subValue" class="d-flex">
        {{ I18n.Common.by | translate}}
        <div
        class="sub-value flex-1"
        [tooltip]="item.subValue"
        placement="bottom"
        >
        {{ item.subValue | translate }}</div>
      </div>
      <div class="item-group"></div>
    </div>
    <div *ngIf="block.divider" class="sidebar-section"></div>
  </div>
</div>
